// https://github.com/coverslide/node-alea/blob/master/alea.js
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/dworthen/prng
var Alea = /** @class */ (function () {
    function Alea(args) {
        var _this = this;
        this.s0 = 0;
        this.s1 = 0;
        this.s2 = 0;
        this.c = 1;
        this.random = function (decimal) {
            var t = 2091639 * _this.s0 + _this.c * 2.3283064365386963e-10; // 2^-32
            _this.s0 = _this.s1;
            _this.s1 = _this.s2;
            _this.c = t | 0;
            _this.s2 = t - _this.c;
            var random = _this.s2;
            return decimal !== undefined ? Math.floor(random * decimal) : random;
        };
        if (typeof args === "string") {
            var mash = Mash();
            this.s0 = mash(" ");
            this.s1 = mash(" ");
            this.s2 = mash(" ");
            for (var i = 0; i < args.length; i++) {
                this.s0 -= mash(args[i]);
                if (this.s0 < 0) {
                    this.s0 += 1;
                }
                this.s1 -= mash(args[i]);
                if (this.s1 < 0) {
                    this.s1 += 1;
                }
                this.s2 -= mash(args[i]);
                if (this.s2 < 0) {
                    this.s2 += 1;
                }
            }
        }
        else {
            this.importState(args);
        }
    }
    /*
      uint32() {
          return this.random() * 0x100000000; // 2^32
      }
  
      fract53() {
          return (
              this.random() +
              ((this.random() * 0x200000) | 0) * 1.1102230246251565e-16
          ); // 2^-53
      }
      */
    Alea.prototype.exportState = function () {
        return [this.s0, this.s1, this.s2, this.c];
    };
    Alea.prototype.importState = function (params) {
        this.s0 = +params[0] || 0;
        this.s1 = +params[1] || 0;
        this.s2 = +params[2] || 0;
        this.c = +params[3] || 0;
    };
    return Alea;
}());
export { Alea };
function Mash() {
    var n = 0xefc8249d;
    var mash = function (data) {
        // data = data.toString();
        for (var i = 0; i < data.length; i++) {
            n += data.charCodeAt(i);
            var h = 0.02519603282416938 * n;
            n = h >>> 0;
            h -= n;
            h *= n;
            n = h >>> 0;
            h -= n;
            n += h * 0x100000000; // 2^32
        }
        return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
    };
    // mash.version = 'Mash 0.9';
    return mash;
}
/*
const a = new Alea('');
console.info(a.random(100));
console.info(a.random(100));
console.info(a.random(100));
console.info(a.random(100));
*/
//# sourceMappingURL=data:application/json;base64,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